<mat-card>
  <mat-card-content>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Supplier" matInput [formControl]="supplierControl" [matAutocomplete]="supplierAuto" (focus)="loadFilterSupplierOptions()">
          <button mat-button *ngIf="supplierNameFilter || supplierControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearSupplier()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #supplierAuto="matAutocomplete" (optionSelected)="onSupplierSelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingSuppliers" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingSuppliers>
              <mat-option *ngIf="!loadingFilterOption && !(filteredSuppliers | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let supplier of filteredSuppliers | async" [value]="supplier.name">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <img class="company-logo" *ngIf="supplier?.companyLogoUrl" [lazyLoad]="supplier.companyLogoUrl" [matTooltip]="supplier.name" />
                    <span [class.default-value]="isDefaultId(supplier.id)" [innerHtml]="supplier.name | encodeHtml | highlight: supplierControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Brand" matInput [formControl]="brandControl" [matAutocomplete]="brandAuto" (focus)="loadFilterBrandOptions()">
          <button mat-button *ngIf="brandNameFilter || brandControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearBrand()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #brandAuto="matAutocomplete" (optionSelected)="onBrandSelected($event)" [displayWith]="displayBrandFilterName">

            <mat-option *ngIf="loadingFilterOption; else notLoadingBrands" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingBrands>
              <mat-option *ngIf="!(filteredBrands | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let brand of filteredBrands | async" [value]="brand.id">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <img class="brand-logo" *ngIf="brand?.brandLogoUrl" [lazyLoad]="brand.brandLogoUrl" [matTooltip]="brand.name" />
                    <span [class.default-value]="isDefaultId(brand.id)" [innerHtml]="brand.name | encodeHtml | highlight: brandControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Import Company" matInput [formControl]="importCompanyControl" [matAutocomplete]="importCompanyAuto" (focus)="loadFilterImportCompanyOptions()">
          <button mat-button *ngIf="importCompanyNameFilter || importCompanyControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearImportCompany()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #importCompanyAuto="matAutocomplete" (optionSelected)="onImportCompanySelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingImportCompanies" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingImportCompanies>
            <mat-option *ngIf="!(filteredImportCompanies | async)?.length" disabled>
              No items
            </mat-option>

            <mat-option *ngFor="let importCompany of filteredImportCompanies | async" [value]="importCompany.name">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                  <img class="company-logo" *ngIf="importCompany?.companyLogoUrl" [lazyLoad]="importCompany.companyLogoUrl" [matTooltip]="importCompany.name" />
                  <span [class.default-value]="isDefaultId(importCompany.id)" [innerHtml]="importCompany.name | encodeHtml | highlight: importCompanyControl.value"></span>
                </div>
            </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Import File" matInput [formControl]="importFileControl" [matAutocomplete]="importFileAuto" (focus)="loadFilterImportFileOptions()">
          <button mat-button *ngIf="importFileNameFilter || importFileControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearImportFile()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #importFileAuto="matAutocomplete" (optionSelected)="onImportFileSelected($event)" [displayWith]="displayImportFileName">

            <mat-option *ngIf="loadingFilterOption; else notLoadingImportFiles" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingImportFiles>
            <mat-option *ngIf="!(filteredImportFiles | async)?.length" disabled>
              No items
            </mat-option>

            <mat-option *ngFor="let importFile of filteredImportFiles | async" [value]="importFile.id">
                <div style="line-height: initial;" fxLayout="column" fxLayoutAlign="center start">

                    <span [innerHtml]="importFile.name | encodeHtml | highlight: importFileControl.value"></span>

                    <small>
                      <span *ngIf="!importFile.confirmed"><span class="text-warning">Awaiting Confirmation</span> - </span>
                      {{ importRequestedProductCount(importFile) }} Items Imported by {{ importFile.companyName }} <span [matTooltip]="importFile.importedDate">{{ timeAgoString(importFile.importedDate) }}.</span>
                    </small>

                </div>
            </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

    </div>
    
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Product Classification" matInput [formControl]="productClassificationControl" [matAutocomplete]="productClassificationAuto" (focus)="loadFilterProductClassificationOptions()">
          <button mat-button *ngIf="productClassificationNameFilter || productClassificationControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductClassification()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #productClassificationAuto="matAutocomplete" (optionSelected)="onProductClassificationSelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingProductClassifications" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingProductClassifications>
              <mat-option *ngIf="!(filteredProductClassifications | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let productClassification of filteredProductClassifications | async" [value]="productClassification.name">
                  <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span [innerHtml]="productClassification.name | encodeHtml | highlight: productClassificationControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Product Type" matInput [formControl]="productTypeControl" [matAutocomplete]="productTypeAuto" (focus)="loadFilterProductTypeOptions()">
          <button mat-button *ngIf="productTypeNameFilter || productTypeControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductType()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete #productTypeAuto="matAutocomplete" (optionSelected)="onProductTypeSelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingProductTypes" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingProductTypes>
              <mat-option *ngIf="!(filteredProductTypes | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let productType of filteredProductTypes | async" [value]="productType.name">
                  <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <span [innerHtml]="productType.name | encodeHtml | highlight: productTypeControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>
        </mat-form-field>
      </form>

      <form fxFlex="50">
        <mat-form-field>
          <input matInput type="text" placeholder="Filter by Product State" matInput [formControl]="productStateControl" [matAutocomplete]="productStateAuto" (focus)="loadFilterProductStateOptions()">
          <button mat-button *ngIf="productStateNameFilter || productStateControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="onClearProductState()">
            <mat-icon>close</mat-icon>
          </button>

          <mat-autocomplete #productStateAuto="matAutocomplete" (optionSelected)="onProductStateSelected($event)">

            <mat-option *ngIf="loadingFilterOption; else notLoadingProductStates" disabled>
              <div fxLayout="row" fxLayoutAlign="center center"  fxLayoutGap="5px">
                <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
                <span>Loading...</span>
              </div>
            </mat-option>

            <ng-template #notLoadingProductStates>
              <mat-option *ngIf="!(filteredProductStates | async)?.length" disabled>
                No items
              </mat-option>

              <mat-option *ngFor="let productState of filteredProductStates | async" [value]="productState.name">
                  <div class="w-100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <product-workflow-icon id="workflow-state-list-icon"
                      [workflowStateType]="productState.stateType">
                    </product-workflow-icon>
                    <span [innerHtml]="productState.name | encodeHtml | highlight: productStateControl.value"></span>
                  </div>
              </mat-option>
            </ng-template>

          </mat-autocomplete>

        </mat-form-field>
      </form>
      
    </div>

    <mat-form-field class="accent">
      <mat-label>Search Filter</mat-label>
      <input matInput type="text" name="searchTerm"
          [(ngModel)]="searchTerm"
          (keyup.esc)="clearSearchTerm()"
          (change)="searchTermChanged()">
      <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearchTerm()">
          <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <div fxLayout="row" fxLayoutAlign="space-between center" >

      <div fxLayout="row" fxLayoutGap="15px">
        <button mat-button type="submit" mat-flat-button color="primary" (click)="onSearch()">
          <mat-icon>search</mat-icon> Search
        </button>
      </div>

      
      <div fxLayout="row" fxLayoutGap="15px">
        <a mat-mini-fab color="primary" aria-label="Download Bulk Import Template" matTooltip="Download Bulk Import Template" href="https://cdn.situsystems.com/product-templates/requested_product_template.xlsx">
          <mat-icon>file_download</mat-icon>
        </a>

        <button mat-button type="submit" mat-flat-button color="primary" (click)="onImportRequestedProductsClick()">
          <mat-icon>file_upload</mat-icon> Import Requested Products
          <input class="upload-input" id="upload-requested-product-file" [(ngModel)]="filename" type="file" (change)="onFileChosen($event)" onclick="value = null" accept=".xlsx" />
        </button>
      </div>

    </div>

  </mat-card-content>
</mat-card>

<mat-card *ngIf="selectedImportFile">
  <mat-card-content>

    <div fxLayout="row" fxLayoutAlign="space-between start">
      <div fxLayout="column" fxLayoutAlign="start start">
        <span>{{ selectedImportFile.name }}</span>
        <small>{{ importRequestedProductCount(selectedImportFile) }} Items Imported by {{ selectedImportFile.companyName }} <span [matTooltip]="selectedImportFile.importedDate">{{ timeAgoString(selectedImportFile.importedDate) }}.</span></small>
      </div>

      <div>
        <div *ngIf="!selectedImportFile.confirmed" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="15px">
          <b class="text-info">This Import is Awaiting Confirmation.</b>
          <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
            <button mat-button mat-flat-button color="accent" (click)="confirmImport(true)">
              <mat-icon>check</mat-icon> Confirm Import
            </button>
            <button mat-button mat-flat-button color="primary" (click)="confirmImport(false)">
              <mat-icon>close</mat-icon> Cancel Import
            </button>
          </div>
        </div>

        <div *ngIf="selectedImportFile.confirmed" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="2px">
          <div *ngFor="let stateCount of selectedImportFile.requestedProductCount" [matTooltip]="stateCount.description" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"> 
            <product-workflow-icon id="workflow-state-list-icon" [workflowStateType]="stateCount.stateType"></product-workflow-icon>
            <span>{{ stateCount.name }} <small>({{ stateCount.count }} {{ pluralize("Item", stateCount.count) }})</small></span>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>


<mat-card>
  <table mat-table class="resizable-table no-hover-highlight" [dataSource]="requestedProducts" matSort (matSortChange)="sortData($event)" fxFill>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <div *ngIf="item.allowEditMode()" class="requested-product-selector" [ngClass]="{'requested-product-selector-selected': item.editMode}" fxLayout="column" fxLayoutAlign="center center">
          <mat-icon *ngIf="item.editMode" (click)="cancelEditMode(item)" matTooltip="Deselect Requested Product">check_box</mat-icon>
          <mat-icon *ngIf="!item.editMode" (click)="enableEditMode(item)" matTooltip="Select Requested Product">check_box_outline_blank</mat-icon>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div fxLayout="column" fxLayoutAlign="center center">
          <mat-icon *ngIf="hasEditModeLineItems()" (click)="editAllLineItems(false)" matTooltip="Deselect all Requested Products">deselect</mat-icon>
          <mat-icon *ngIf="!hasEditModeLineItems()" (click)="editAllLineItems(true)" matTooltip="Select all Requested Products">select_all</mat-icon>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="supplier">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Supplier <span class="text-info">*</span> </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell" [ngClass]="{'missing-required-field': !item.requestedProduct.supplierId && item.requestedProduct.currentWorkflowState.state === productWorkflowState.NewRequest}">
          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
            <small [matTooltip]="item.requestedProduct.requestedSupplierName" class="cell-requested-value no-wrap" [ngStyle]="{'font-style': (item.requestedProduct.requestedSupplierName) ? 'normal' : 'italic'}">
              {{item.requestedProduct.requestedSupplierName ?? "(blank)"}}
            </small>
            <mat-icon *ngIf="!item.editMode && item.allowEditMode()" class="requested-value-icon" color="accent" inline (click)="editSameRequestedSupplierName(item.requestedProduct.requestedSupplierName, true)" matTooltip="Edit Requested Products with the same Requested Supplier Name">select_all</mat-icon>
            <mat-icon *ngIf="item.editMode" class="requested-value-icon" color="accent" inline (click)="editSameRequestedSupplierName(item.requestedProduct.requestedSupplierName, false)" matTooltip="Cancel Editing Requested Products with the same Requested Supplier Name">deselect</mat-icon>
          </div>

          <div *ngIf="item.editMode">
            <small>
              <mat-error *ngIf="!item.supplierControl.value && !item.requestedProduct.supplierId">
                Supplier is required
              </mat-error>
              <mat-error *ngIf="item.supplierControl.value && !item.requestedProduct.supplierId">
                Invalid Supplier
              </mat-error>
            </small>

            <form class="cell-form">
              <input type="text" class="cell-value-input" placeholder="Select a Supplier" [formControl]="item.supplierControl" [matAutocomplete]="supplierAuto">
              <mat-autocomplete #supplierAuto="matAutocomplete" (optionSelected)="onLineItemSupplierSelected($event, item)" (opened)="item.clearSupplier()">
                <mat-option [value]="null"><span><i>Unset</i></span></mat-option>
                <mat-option *ngFor="let supplier of item.filteredSuppliers | async" [value]="supplier.name">
                  <span [innerHtml]="supplier.name | encodeHtml | highlight: item.supplierControl.value"></span>
                </mat-option>
              </mat-autocomplete>
            </form>
          </div>
          <div class="no-wrap cell-value-readonly" *ngIf="!item.editMode" [matTooltip]="companyDirectory[item.requestedProduct.supplierId]">
            {{ companyDirectory[item.requestedProduct.supplierId] }}
          </div>
          
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Supplier:
          </span>

          <form class="cell-form">
            <input type="text" class="cell-value-input" placeholder="Select a Supplier" [formControl]="bulkSupplierControl" [matAutocomplete]="supplierAuto">
            <mat-autocomplete #supplierAuto="matAutocomplete" (optionSelected)="onBulkSupplierSelected($event)" (opened)="clearBulkSupplier()">
              <mat-option *ngFor="let supplier of filteredBulkSuppliers | async" [value]="supplier.name">
                <span [innerHtml]="supplier.name | encodeHtml | highlight: bulkSupplierControl.value"></span>
              </mat-option>
            </mat-autocomplete>
          </form>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Name <span class="text-info">*</span> </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell" [ngClass]="{'missing-required-field': !item.requestedProduct.name && item.requestedProduct.currentWorkflowState.state === productWorkflowState.NewRequest}">
          <small class="cell-requested-value no-wrap" [matTooltip]="item.requestedProduct.requestedName" [ngStyle]="{'font-style': (item.requestedProduct.requestedName) ? 'normal' : 'italic'}">
            {{item.requestedProduct.requestedName ?? "(blank)"}}
          </small>

          <div *ngIf="item.editMode">
            <small>
              <mat-error *ngIf="!item.requestedProduct.name">
                Name is required
              </mat-error>
            </small>
  
            <form class="cell-form">
              <input type="text" class="cell-value-input" [(ngModel)]="item.requestedProduct.name" [ngModelOptions]="{standalone: true}">
            </form>
          </div>
          <div class="no-wrap cell-value-readonly" *ngIf="!item.editMode" [matTooltip]="item.requestedProduct.name">
            {{ item.requestedProduct.name }}
          </div>

        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="productCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Product Code </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">
          <small class="cell-requested-value no-wrap" [ngStyle]="{'font-style': (item.requestedProduct.requestedProductCode) ? 'normal' : 'italic'}" [matTooltip]="item.requestedProduct.requestedProductCode">
            {{item.requestedProduct.requestedProductCode ?? "(blank)"}}
          </small>

          <div *ngIf="item.editMode">
            <form class="cell-form">
              <input type="text" class="cell-value-input" [(ngModel)]="item.requestedProduct.productCode" [ngModelOptions]="{standalone: true}">
            </form>
          </div>
          <div class="no-wrap cell-value-readonly" *ngIf="!item.editMode" [matTooltip]="item.requestedProduct.productCode">
            {{ item.requestedProduct.productCode }}
          </div>

        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="productType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Product Type <span class="text-info">*</span> </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell" [ngClass]="{'missing-required-field': !item.requestedProduct.productTypeId && item.requestedProduct.currentWorkflowState.state === productWorkflowState.NewRequest}">
          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
            <small class="cell-requested-value no-wrap" [matTooltip]="item.requestedProduct.requestedProductTypeName" [ngStyle]="{'font-style': (item.requestedProduct.requestedProductTypeName) ? 'normal' : 'italic'}">
              {{item.requestedProduct.requestedProductTypeName ?? "(blank)"}}
            </small>
            <mat-icon *ngIf="!item.editMode && item.allowEditMode()" class="requested-value-icon" color="accent" inline (click)="editSameRequestedProductTypeName(item.requestedProduct.requestedProductTypeName, true)" matTooltip="Edit Requested Products with the same Requested Product Type Name">select_all</mat-icon>
            <mat-icon *ngIf="item.editMode" class="requested-value-icon" color="accent" inline (click)="editSameRequestedProductTypeName(item.requestedProduct.requestedProductTypeName, false)" matTooltip="Cancel Editing Requested Products with the same Requested Product Type Name">deselect</mat-icon>
          </div>

          <div *ngIf="item.editMode">
            <small>
              <mat-error *ngIf="!item.productTypeControl.value && !item.requestedProduct.productTypeId">
                Product Type is required
              </mat-error>
              <mat-error *ngIf="item.productTypeControl.value && !item.requestedProduct.productTypeId">
                Invalid Product Type
              </mat-error>
            </small>
  
            <form class="cell-form">
              <input type="text" class="cell-value-input" placeholder="Select a Product Type" [formControl]="item.productTypeControl" [matAutocomplete]="productTypeAuto">
              <mat-autocomplete #productTypeAuto="matAutocomplete" (optionSelected)="onLineItemProductTypeSelected($event, item)" (opened)="item.clearProductType()">
                <mat-option [value]="null"><span><i>Unset</i></span></mat-option>
                <mat-option *ngFor="let productType of item.filteredProductTypes | async" [value]="productType.name">
                  <span [innerHtml]="productType.name | encodeHtml | highlight: item.productTypeControl.value"></span>
                </mat-option>
              </mat-autocomplete>
            </form>
          </div>
          <div class="no-wrap cell-value-readonly" *ngIf="!item.editMode" [matTooltip]="getProductTypeName(item.requestedProduct)">
            {{ getProductTypeName(item.requestedProduct) }}
          </div>

        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Product Type:
          </span>

          <form class="cell-form">
            <input type="text" class="cell-value-input" placeholder="Select a Product Type" [formControl]="bulkProductTypeControl" [matAutocomplete]="productTypeAuto">
            <mat-autocomplete #productTypeAuto="matAutocomplete" (optionSelected)="onBulkProductTypeSelected($event)" (opened)="clearBulkProductType()">
              <mat-option *ngFor="let productType of filteredBulkProductTypes | async" [value]="productType.name">
                <span [innerHtml]="productType.name | encodeHtml | highlight: bulkProductTypeControl.value"></span>
              </mat-option>
            </mat-autocomplete>
          </form>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef appColumnResize> Description </th>

      <td mat-cell *matCellDef="let item">
        <div class="cell">
          <small class="cell-requested-value no-wrap" [ngStyle]="{'font-style': (item.requestedProduct.requestedDescription) ? 'normal' : 'italic'}" [matTooltip]="item.requestedProduct.requestedDescription">
            {{item.requestedProduct.requestedDescription ?? "(blank)"}}
          </small>

          <div *ngIf="item.editMode">
            <form class="cell-form">
              <textarea  class="cell-value-input" [(ngModel)]="item.requestedProduct.description" [ngModelOptions]="{standalone: true}"></textarea>
            </form>
          </div>
          <div class="two-line-wrap cell-value-readonly" *ngIf="!item.editMode" [matTooltip]="item.requestedProduct.description">
            {{ item.requestedProduct.description }}
          </div>

        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Brand </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
            <small class="cell-requested-value no-wrap" [ngStyle]="{'font-style': (item.requestedProduct.requestedBrand) ? 'normal' : 'italic'}" [matTooltip]="item.requestedProduct.requestedBrand">
              {{item.requestedProduct.requestedBrand ?? "(blank)"}}
            </small>
            <mat-icon *ngIf="!item.editMode && item.allowEditMode()" class="requested-value-icon" color="accent" inline (click)="editSameRequestedBrand(item.requestedProduct.requestedBrand, true)" matTooltip="Edit Requested Products with the same Requested Brand">select_all</mat-icon>
            <mat-icon *ngIf="item.editMode" class="requested-value-icon" color="accent" inline (click)="editSameRequestedBrand(item.requestedProduct.requestedBrand, false)" matTooltip="Cancel Editing Requested Products with the same Requested Brand">deselect</mat-icon>
          </div>

          
          <div *ngIf="item.editMode">
            <small>
              <mat-error *ngIf="item.brandControl.value && !item.requestedProduct.brandId">
                Invalid Brand
              </mat-error>
            </small>
  
            <form class="cell-form">
              <input type="text" class="cell-value-input" placeholder="Select a Brand" [formControl]="item.brandControl" [matAutocomplete]="brandAuto">
              <mat-autocomplete #brandAuto="matAutocomplete" (optionSelected)="onLineItemBrandSelected($event, item)" (opened)="item.clearBrand()" [displayWith]="displayBrandName">
                <small>Showing Brands for <em>{{companyDirectory[item.requestedProduct.supplierId]}}</em></small>
                <mat-option [value]="null"><span><i>None</i></span></mat-option>
                <mat-option *ngFor="let brand of item.filteredBrands | async" [value]="brand.id">
                  <span [innerHtml]="brand.name | encodeHtml | highlight: item.brandControl.value"></span>
                </mat-option>
              </mat-autocomplete>
            </form>
          </div>
          <div class="no-wrap cell-value-readonly" *ngIf="!item.editMode" [matTooltip]="brandDirectory[item.requestedProduct.brandId] ? brandDirectory[item.requestedProduct.brandId] : item.requestedProduct.brandId">
            {{ getBrandName(item.requestedProduct.brandId) }}
          </div>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Brand:
          </span>

          <form class="cell-form">
            <input type="text" class="cell-value-input" placeholder="Select a Brand" [formControl]="bulkBrandControl" [matAutocomplete]="bulkBrandAuto">
            <mat-autocomplete #bulkBrandAuto="matAutocomplete" (optionSelected)="onBulkBrandSelected($event)" (opened)="clearBulkBrand()" [displayWith]="displayBrandName">
              <mat-option [value]="null">None</mat-option>
              <mat-option *ngFor="let brand of filteredBulkBrands | async" [value]="brand.id">
                <span [innerHtml]="brand.name | encodeHtml | highlight: bulkBrandControl.value"></span>
              </mat-option>
            </mat-autocomplete>
          </form>
        </div>

      </td>
    </ng-container>

    <ng-container matColumnDef="ranges">
      <th mat-header-cell *matHeaderCellDef appColumnResize> Ranges </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <!-- Show (blank) when no ranges at all -->
          <div *ngIf="!item.requestedProduct.ranges?.length">
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
              <small class="cell-requested-value no-wrap" [ngStyle]="{'font-style': 'italic'}">
                (blank)
              </small>
              <mat-icon *ngIf="!item.editMode && item.allowEditMode()" class="requested-value-icon" color="accent" inline (click)="editSameRequestedRange(null, true)" matTooltip="Edit Requested Products with no Ranges">select_all</mat-icon>
              <mat-icon *ngIf="item.editMode" class="requested-value-icon" color="accent" inline (click)="editSameRequestedRange(null, false)" matTooltip="Cancel Editing Requested Products with no Ranges">deselect</mat-icon>
            </div>
          </div>

          <!-- Import ranges (from XLSX) -->
          <div *ngFor="let rangeRow of getImportRanges(item.requestedProduct)" class="import-row">
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
              <small class="cell-requested-value no-wrap" [ngStyle]="{'font-style': (rangeRow.requestedRangeName) ? 'normal' : 'italic'}" [matTooltip]="rangeRow.requestedRangeName">
                {{rangeRow.requestedRangeName ?? "(blank)"}}
              </small>
              <mat-icon *ngIf="!item.editMode && item.allowEditMode()" class="requested-value-icon" color="accent" inline (click)="editSameRequestedRange(rangeRow.requestedRangeName, true)" [matTooltip]="'Edit Requested Products with the same Requested Range: ' + (rangeRow.requestedRangeName ?? '(blank)')">select_all</mat-icon>
              <mat-icon *ngIf="item.editMode" class="requested-value-icon" color="accent" inline (click)="editSameRequestedRange(rangeRow.requestedRangeName, false)" [matTooltip]="'Cancel Editing Requested Products with the same Requested Range: ' + (rangeRow.requestedRangeName ?? '(blank)')">deselect</mat-icon>
            </div>
            <div *ngIf="rangeRow.range && !isRangePickerOpen(item, rangeRow)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
              <span class="resolved-value">{{rangeRow.range.name}}</span>
              <ng-container *ngIf="item.editMode">
                <mat-icon class="inline-action-icon" color="accent" inline matTooltip="Swap Range" (click)="openRangePicker(item, rangeRow)">swap_horiz</mat-icon>
                <mat-icon class="inline-action-icon" color="accent" inline matTooltip="Remove Range" (click)="onClearRange(rangeRow, item)">close</mat-icon>
              </ng-container>
            </div>
            <div *ngIf="!rangeRow.range && !isRangePickerOpen(item, rangeRow)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
              <em class="unset-value">unset</em>
              <mat-icon *ngIf="item.editMode" class="inline-action-icon" color="accent" inline matTooltip="Set Range" (click)="openRangePicker(item, rangeRow)">add</mat-icon>
            </div>
            <div *ngIf="isRangePickerOpen(item, rangeRow)" class="inline-picker">
              <input type="text" class="cell-value-input" placeholder="Select a Range" [formControl]="rangePickerControl" [matAutocomplete]="inlineRangeAuto">
              <mat-autocomplete #inlineRangeAuto="matAutocomplete" (optionSelected)="onRangePickerSelected($event)" (closed)="closeRangePicker()">
                <small>Showing Ranges for <em>{{companyDirectory[item.requestedProduct.supplierId]}}</em></small>
                <mat-option *ngFor="let range of filterRangesForSupplier(rangePickerControl.value, item.requestedProduct.supplierId)" [value]="range.name">
                  <span>{{range.name}}</span>
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>

          <!-- Manual ranges (user-added) + Add range -->
          <div *ngIf="getManualRanges(item.requestedProduct).length || item.editMode" class="manual-section">
            <small class="manual-section-label">Additional ranges:</small>
            <div *ngFor="let rangeRow of getManualRanges(item.requestedProduct)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
              <span class="resolved-value">{{rangeRow.range!.name}}</span>
              <ng-container *ngIf="item.editMode">
                <mat-icon class="inline-action-icon" color="accent" inline matTooltip="Swap Range" (click)="openRangePicker(item, rangeRow)">swap_horiz</mat-icon>
                <mat-icon class="inline-action-icon" color="accent" inline matTooltip="Remove Range" (click)="onClearRange(rangeRow, item)">close</mat-icon>
              </ng-container>
            </div>
            <div *ngIf="item.editMode">
              <div *ngIf="!isRangePickerOpen(item)">
                <a class="add-link" (click)="openRangePicker(item)">Add Range +</a>
              </div>
              <div *ngIf="isRangePickerOpen(item)" class="inline-picker">
                <input type="text" class="cell-value-input" placeholder="Add a Range" [formControl]="rangePickerControl" [matAutocomplete]="addRangeAuto">
                <mat-autocomplete #addRangeAuto="matAutocomplete" (optionSelected)="onRangePickerSelected($event)" (closed)="closeRangePicker()">
                  <small>Showing Ranges for <em>{{companyDirectory[item.requestedProduct.supplierId]}}</em></small>
                  <mat-option *ngFor="let range of filterRangesForSupplier(rangePickerControl.value, item.requestedProduct.supplierId)" [value]="range.name">
                    <span>{{range.name}}</span>
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <ng-container *ngIf="getEditModeCommonSupplierId(); else multipleSuppliers">
            <span>
              Bulk Add Range:
            </span>

            <form class="cell-form">
              <input type="text" class="cell-value-input" placeholder="Add a Range" [formControl]="bulkRangeControl" [matAutocomplete]="bulkRangeAuto" (focus)="onBulkRangePickerOpened()">
              <mat-autocomplete #bulkRangeAuto="matAutocomplete" (optionSelected)="onBulkRangeSelected($event)">
                <small>Showing Ranges for <em>{{companyDirectory[getEditModeCommonSupplierId()!]}}</em></small>
                <mat-option *ngFor="let range of filteredBulkRanges | async" [value]="range.name">
                  <span [innerHtml]="range.name | encodeHtml | highlight: bulkRangeControl.value"></span>
                </mat-option>
              </mat-autocomplete>
            </form>

          </ng-container>

          <ng-template #multipleSuppliers>
            <small class="unset-value">Select products from the same supplier to bulk add ranges</small>
          </ng-template>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="fileVaultFiles">
      <th mat-header-cell *matHeaderCellDef appColumnResize> File Vault Files </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">

          <!-- Show (blank) when no file vault references at all -->
          <div *ngIf="!item.requestedProduct.fileVaultReferences?.length">
            <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
              <small class="cell-requested-value no-wrap" [ngStyle]="{'font-style': 'italic'}">
                (blank)
              </small>
              <mat-icon *ngIf="!item.editMode && item.allowEditMode()" class="requested-value-icon" color="accent" inline (click)="editSameRequestedFileVaultFiles(null, null, true)" matTooltip="Edit Requested Products with no File Vault Files">select_all</mat-icon>
              <mat-icon *ngIf="item.editMode" class="requested-value-icon" color="accent" inline (click)="editSameRequestedFileVaultFiles(null, null, false)" matTooltip="Cancel Editing Requested Products with no File Vault Files">deselect</mat-icon>
            </div>
          </div>

          <!-- Group by category -->
          <div *ngFor="let category of getFileCategories(item.requestedProduct)" class="file-category-group">
            <small class="category-label">{{getCategoryLabel(category)}}</small>

            <!-- Import files (from XLSX) -->
            <div *ngFor="let fileRow of getImportFilesByCategory(item.requestedProduct, category)" class="import-row">
              <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
                <small class="cell-requested-value no-wrap" [ngStyle]="{'font-style': (fileRow.requestedFileVaultFile) ? 'normal' : 'italic'}" [matTooltip]="fileRow.requestedFileVaultFile">
                  {{fileRow.requestedFileVaultFile ?? "(blank)"}}
                </small>
                <mat-icon *ngIf="!item.editMode && item.allowEditMode()" class="requested-value-icon" color="accent" inline (click)="editSameRequestedFileVaultFiles(fileRow.requestedFileVaultFile, category, true)" [matTooltip]="'Edit Requested Products with the same Requested File: ' + (fileRow.requestedFileVaultFile ?? '(blank)')">select_all</mat-icon>
                <mat-icon *ngIf="item.editMode" class="requested-value-icon" color="accent" inline (click)="editSameRequestedFileVaultFiles(fileRow.requestedFileVaultFile, category, false)" [matTooltip]="'Cancel Editing Requested Products with the same Requested File: ' + (fileRow.requestedFileVaultFile ?? '(blank)')">deselect</mat-icon>
              </div>
              <div *ngIf="fileRow.fileVaultReference" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
                <span class="resolved-value" [matTooltip]="fileRow.fileVaultReference.fileName">{{fileRow.fileVaultReference.fileName}}</span>
                <ng-container *ngIf="item.editMode">
                  <mat-icon class="inline-action-icon" color="accent" inline matTooltip="Swap File" (click)="onSwapFile(fileRow, item)">swap_horiz</mat-icon>
                  <mat-icon class="inline-action-icon" color="accent" inline matTooltip="Remove File" (click)="onClearFile(fileRow, item)">close</mat-icon>
                </ng-container>
              </div>
              <div *ngIf="!fileRow.fileVaultReference" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
                <em class="unset-value">unset</em>
                <mat-icon *ngIf="item.editMode" class="inline-action-icon" color="accent" inline matTooltip="Set File" (click)="onAddFileToUnmatched(fileRow, item)">attach_file</mat-icon>
              </div>
            </div>

            <!-- Manual files (user-added) -->
            <div *ngIf="getManualFilesByCategory(item.requestedProduct, category).length" class="manual-section">
              <small class="manual-section-label">Additional:</small>
              <div *ngFor="let fileRow of getManualFilesByCategory(item.requestedProduct, category)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px">
                <span class="resolved-value" [matTooltip]="fileRow.fileVaultReference!.fileName">{{fileRow.fileVaultReference!.fileName}}</span>
                <mat-icon *ngIf="item.editMode" class="inline-action-icon" color="accent" inline matTooltip="Remove File" (click)="onClearFile(fileRow, item)">close</mat-icon>
              </div>
            </div>

          </div>

          <!-- Add file (edit mode) -->
          <a *ngIf="item.editMode" class="add-link" (click)="onAddManualFile(item)">Add File +</a>

        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <ng-container *ngIf="getEditModeCommonSupplierId(); else multipleFileVaultSuppliers">
            <span>
              Bulk Add File:
            </span>
            <a class="add-link" (click)="onBulkAddFileVault()">Add File +</a>
          </ng-container>

          <ng-template #multipleFileVaultSuppliers>
            <small class="unset-value">Select products from the same supplier to bulk add files</small>
          </ng-template>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="qualityLevel">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> Quality Level </th>
      <td mat-cell *matCellDef="let item">
        <div class="cell">
          <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px">
            <small class="cell-requested-value no-wrap" [matTooltip]="item.requestedProduct.requestedQualityLevel" [ngStyle]="{'font-style': (item.requestedProduct.requestedQualityLevel != null) ? 'normal' : 'italic'}">
              {{item.requestedProduct.requestedQualityLevel ?? "(blank)"}}
            </small>
            <mat-icon *ngIf="!item.editMode && item.allowEditMode()" class="requested-value-icon" color="accent" inline
              (click)="editSameRequestedQualityLevel(item.requestedProduct.requestedQualityLevel, true)"
              matTooltip="Edit Requested Products with the same Requested Quality Level">select_all</mat-icon>
            <mat-icon *ngIf="item.editMode" class="requested-value-icon" color="accent" inline
              (click)="editSameRequestedQualityLevel(item.requestedProduct.requestedQualityLevel, false)"
              matTooltip="Cancel Editing Requested Products with the same Requested Quality Level">deselect</mat-icon>
          </div>
    
          <div *ngIf="item.editMode">
            <form class="cell-form">
              <select class="cell-value-input" [ngModel]="item.requestedProduct.qualityLevel" (change)="item.requestedProduct.qualityLevel = Number($event.target.value)"
                [ngModelOptions]="{standalone: true}" ariaPlaceholder="Select a Quality Level">
                <option  [value]="null">None</option>
                <ng-container *ngFor="let quality of QualityLevel | enumKeyValue">
                  <option mat-option [value]="quality.value">{{quality.key}}</option>
                </ng-container>
              </select>
            </form>
          </div>
          <div class="no-wrap cell-value-readonly" *ngIf="!item.editMode"
            [matTooltip]=" 'Quality' + (!item.requestedProduct.qualityLevel ? ' inherited from Brand' : '') ">
            <ng-container *ngIf="item.requestedProduct.qualityLevel">
              <span>{{ QualityLevel[item.requestedProduct.qualityLevel] }}</span>
            </ng-container>
            <ng-container *ngIf="!item.requestedProduct.qualityLevel && item.requestedProduct.brand?.qualityLevel">
              <span class="inherited-quality">*{{ QualityLevel[item.requestedProduct.brand.qualityLevel]}}</span>
            </ng-container>
          </div>
          </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Quality Level:
          </span>

          <form class="cell-form">
            <select class="cell-value-input" (change)="onBulkQualityLevelChanged($event)" ariaPlaceholder="Select a Quality Level">
              <option  [value]="null">None</option>
              <ng-container *ngFor="let quality of QualityLevel | enumKeyValue">
                <option [value]="quality.value">{{quality.key}}</option>
              </ng-container>
            </select>
          </form>
          </div>

      </td>
    </ng-container>

    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize> State </th>

      <td mat-cell class="state-value" *matCellDef="let item">

        <div class="cell">
          <small></small>

          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <product-workflow-icon id="current-workflow-state-icon"
              [workflowStateType]="item.requestedProduct.currentWorkflowState.stateType">
            </product-workflow-icon>

            <span>
              {{getWorkflowState(item.requestedProduct)}}
            </span>
            <button mat-icon-button *ngIf="isSituUser && item.allowWorkflowTransition()" matTooltip="Open product transition dialog." (click)="onOpenWorkflowDialog(item)">
              <mat-icon class="change-state-icon">alt_route</mat-icon>
            </button>
            <mat-icon *ngIf="isSituUser && !item.editMode && item.allowWorkflowTransition()" class="requested-value-icon" color="accent" inline (click)="editSameProductWorkflowState(item.requestedProduct.currentWorkflowState!.state, true)" matTooltip="Edit Requested Products in the same Product Workflow State">select_all</mat-icon>
            <mat-icon *ngIf="isSituUser && item.editMode" class="requested-value-icon" color="accent" inline (click)="editSameProductWorkflowState(item.requestedProduct.currentWorkflowState!.state, false)" matTooltip="Cancel Editing Requested Products in the same Product Workflow State">deselect</mat-icon>
          </div>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        
        <div class="cell" *ngIf="isSituUser && hasEditModeLineItems()">
          <span>
            Bulk Workflow Transistion:
          </span>

          <div fxLayout="row" fxLayoutAlign="center center">
            <button mat-icon-button matTooltip="Open product transition dialog." [disabled]="!workflowStateOfRequestedProductsInEditModeAreTheSame()" (click)="onBulkOpenWorkflowDialog()">
              <mat-icon class="change-state-icon">alt_route</mat-icon>
            </button>
          </div>
        </div>
        
      </td>
    </ng-container>

    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef appColumnResize> Notes </th>

      <td mat-cell *matCellDef="let item">
        
        <div class="cell">
          <small></small>

          
          <div *ngIf="item.editMode">
            <form class="cell-form">
              <textarea  class="three-line-wrap cell-value-input" [(ngModel)]="item.requestedProduct.notes" [ngModelOptions]="{standalone: true}"></textarea>
            </form>
          </div>
          <div class="three-line-wrap cell-value-readonly" *ngIf="!item.editMode" [matTooltip]="item.requestedProduct.notes">
            {{ item.requestedProduct.notes }}
          </div>

        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>

        
        <div class="cell" *ngIf="hasEditModeLineItems()">
          <span>
            Bulk Set Notes:
          </span>

          <form class="cell-form">
            <input type="text" class="cell-value-input" (input)="onBulkNotesChanged($event)" [ngModelOptions]="{standalone: true}">
          </form>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <div fxLayout="row" fxLayoutAlign="center center">
          <button *ngIf="!item.editMode && item.allowEditMode()" mat-icon-button color="accent" matTooltip="Edit Requested Product" (click)="enableEditMode(item)">
            <mat-icon>edit</mat-icon>
          </button>
          <button *ngIf="item.editMode" mat-icon-button color="accent" matTooltip="Save Requested Product" (click)="onSaveLineItem(item)">
            <mat-icon>save</mat-icon>
          </button>
          <button *ngIf="item.editMode" mat-icon-button color="accent" matTooltip="Cancel Editing Requested Product" (click)="cancelEditMode(item)">
            <mat-icon>close</mat-icon>
          </button>

          <a *ngIf="item.requestedProduct.currentWorkflowState.state >= 100" routerLink="/products/{{ item.requestedProduct.id }}" routerLinkActive="active" target="_blank">
            <mat-icon class="link" color="accent" matTooltip="Edit Product">kitchen</mat-icon>
          </a>
          <a *ngIf="item.requestedProduct.duplicateProductId" routerLink="/products/{{ item.requestedProduct.duplicateProductId }}" routerLinkActive="active" target="_blank">
            <mat-icon class="link" color="accent" matTooltip="View Existing Product">kitchen</mat-icon>
          </a>
        </div>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <div fxLayout="row" fxLayoutAlign="center center">
          <button *ngIf="hasEditModeLineItems()" mat-icon-button color="accent" matTooltip="Save All Requested Products" (click)="onSaveAllEditModeLineItems()">
            <mat-icon>save</mat-icon>
          </button>
          <button *ngIf="hasEditModeLineItems()"mat-icon-button color="accent" matTooltip="Cancel Editing All Requested Product" (click)="editAllLineItems(false)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
  </table>

  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="p-l-20">
      <span>Selected Count: {{countEditModeLineItems()}}</span>
    </div>
    <mat-paginator #paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="[100, 250, 500]" (page)="onPageChange($event)">
    </mat-paginator>
  </div>
</mat-card>
